import toyboxWorkerUrl from 'sphero-sdk/workers/toybox.js?url';

export const getToyboxWorkerUrl = () => toyboxWorkerUrl;

export const getToyboxWorkerPathname = (baseUrl: string) => new URL(toyboxWorkerUrl, baseUrl).pathname;
